'use strict';

var _ = require('lodash');
var RulesReadonlyActionsListingDirective = function RulesReadonlyActionsListingDirective(StrategyRecordService) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/rules-readonly-actions-listing.html'),
    scope: {
      parsedActions: '=',
      level: '=',
      entityType: '='
    },
    link: function link($scope) {
      $scope.hasVisibleCriteriaType = function (action) {
        if (action.criteriaType) {
          return StrategyRecordService.hasVisibleCriteriaType('action', $scope.level, $scope.entityType, action.category, action.criterion);
        }
        return false;
      };
      $scope.getColspan = function (action) {
        var thirdValueValid = action.thirdValue || action.thirdValue === 0;
        var secondValueValid = action.secondValue || action.secondValue === 0;
        return thirdValueValid ? 1 : secondValueValid ? 2 : 3;
      };
    }
  };
};
RulesReadonlyActionsListingDirective.$inject = ['StrategyRecordService'];
module.exports = RulesReadonlyActionsListingDirective;